import { useTranslation } from "@sagot/i18n";
import type { BookingFormValues } from "./booking-form-model";

const P = "build.actions.bookingForm";
/** Same heading and rule as the backend invitation text (`INVITE_DETAILS_HEADING`, `INVITE_RULE`). */
const HEADING = "CLIENT DETAILS";
const RULE = "─".repeat(32);

/** The "CLIENT DETAILS" block the calendar invitation will carry, with sample contact details. */
export function InvitePreview({ values }: { values: BookingFormValues }) {
  const { t } = useTranslation();
  const rows: [string, string][] = [
    ["Name", t(`${P}.previewName`)],
    ["Email", t(`${P}.previewEmail`)],
  ];
  if (values.ask_phone) rows.push(["Phone", t(`${P}.previewPhone`)]);
  for (const field of values.fields) {
    if (field.label.trim()) rows.push([field.label.trim(), t(`${P}.previewAnswer`)]);
  }
  const width = Math.max(...rows.map(([label]) => label.length)) + 2;
  const text = [HEADING, RULE, ...rows.map(([label, value]) => `${`${label}:`.padEnd(width)}${value}`), RULE].join("\n");
  return (
    <div>
      <p className="label mb-0">{t(`${P}.preview`)}</p>
      <p className="mb-2 text-xs text-fg-subtle">{t(`${P}.previewHint`)}</p>
      <pre className="overflow-x-auto rounded-md bg-sunken p-3 font-mono text-xs text-fg-muted" data-testid="invite-preview">{text}</pre>
    </div>
  );
}
